import Hero from './sections/Hero';
import FlashcardsHowItWorks from './sections/HowItWorks';
import FlashcardsFeatures from './sections/Features';

const InteractiveFlashcards = () => {
  return (
    <>
      <Hero />
      <FlashcardsHowItWorks />
      <FlashcardsFeatures />
    </>
  );
};

export default InteractiveFlashcards;
